import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export function HelpFAQ({ items }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-2">
      {items.map((item, i) => (
        <div key={i} className="border border-slate-200 rounded-xl overflow-hidden">
          <button
            className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-slate-50 transition-colors"
            onClick={() => setOpen(open === i ? null : i)}
          >
            <span className="font-medium text-slate-800 text-sm pr-4">{item.q}</span>
            <ChevronDown
              size={16}
              className={`flex-shrink-0 text-slate-400 transition-transform ${open === i ? 'rotate-180' : ''}`}
            />
          </button>
          {open === i && (
            <div className="px-5 pb-4 text-sm text-slate-600 leading-relaxed border-t border-slate-100 pt-3 bg-slate-50">
              {item.a}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
